import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { QuoteService } from '../../../../core/services/quote.service';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { IQuote, IAddQuoteBody, IMasterData, IDeleteKdQuoteBody, Quote, MasterData, IApiResultResponse, IKDQuoteLbl, IPrintMaterialProposalBody, IGetQuoteBody } from '../../../../core/models';
import { Info } from '../../../../core/common';
import { MasterDataService } from '../../../../core/services/master-data.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { HelperService } from '../../../../core/services/helper.service';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from '../../../../core/enums/NotifyType';
import { GridSettings } from '../../../../core/common';
import { StatePersistingService } from '../../../../core/services/state-persisting.service';
import { UserService } from '../../../../core/services/user.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { constant } from 'lodash';

@Component({
  selector: 'app-kawneerdirect-quotes',
  templateUrl: './kawneerdirect-quotes.component.html',
  styleUrls: ['./kawneerdirect-quotes.component.scss']
})
export class KawneerdirectQuotesComponent implements OnInit {

  //#region Member Variables & OnInit & Constructor
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();

  addQuoteForm: FormGroup;
  kdQuoteGridData: GridDataResult;

  quoteGridData: any[] = [];
  marketSegmentsDropdownData: IMasterData[];
  kdQuoteLoading: boolean = true;

  loadingPDF: boolean;
  loadingExcel: boolean;

  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  toDate: Date = new Date();
  fromDate: Date = new Date();
  searchTextKDQuote: string = '';
  constructor(private formBuilder: FormBuilder,
    private masterDataService: MasterDataService,
    private persistingService: StatePersistingService,
    private quoteService: QuoteService,
    private router: Router,
    private helper: HelperService,
    private appNotifyService: AppNotifyService,
    private commonService: CommonService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService) {
    this.fromDate.setDate(this.fromDate.getDate() - 60);
    this.toDate.setHours(this.toDate.getHours() + 6);
    this.removeConfirmation = this.removeConfirmation.bind(this);
    //get grid state from localstorage
    const gridSettings: GridSettings = this.persistingService.get(this.userService.readUserObject.userName
      + 'kdQuoteGridSettings');
    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
    }
  }
  public marketSegments: { name: string, marketSegment: string }[] = [];
  ngOnInit(): void {
    this.loadLanguageTranslationData();
    this.addQuoteForm = this.formBuilder.group({
      jobName: new FormControl(),
      marketSegment: new FormControl(),
      leed: new FormControl(false)
    });
    //getting quote grid data from API
    this.kdQuoteLoading = true;
    this.loadKDQuotes();
    //getting Popup dropdown Data
    this.masterDataService.getMarketSegments(false).then(r => {
      let mktSg: IMasterData[] = r;
      this.marketSegmentsDropdownData = mktSg.filter(m => m.name != 'Other Buildings');    
      
      r.forEach((m: any) => {
        this.marketSegments.push({ name: m.name, marketSegment: m.name });
      });      
     // console.log(this.marketSegments);
    });

    //this.masterDataService.GetMarketSegment().subscribe((res: IApiResultResponse) => {      
    //  if (res.isError == false) {
    //    const data = res.data as IMasterData[];
    /*//    this.marketSegmentsDropdownData = data;*/
    //    data.forEach(m => {
    //    this.marketSegments.push({ name: m.name, marketSegment: m.name });
    //  });
    //  } else {
    //    console.log(res.errorMessage);
    //  }
    //},
    //  error => {
    //    console.log(error);
    //  }
    //);
    this.loadKdHeaderFilterDropdown();
  }
  loadKDQuotes() {
    const body: IGetQuoteBody = {
      customerNumber: '',
      fromDate: this.fromDate,
      toDate: this.toDate
    }
    this.quoteService.getKdQuotes(body).subscribe((response: Array<IQuote>) => {
      this.bindKdQuotesGrid();
      this.kdQuoteLoading = false;
    }, error => {
      this.kdQuoteLoading = false;
      this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
    });

  }

  get f() {
    return this.addQuoteForm.controls
  }

  //#endregion

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "kdQuoteLbl" },
      { controlName: "jobNumberLbl" },
      { controlName: "revlbl" },
      { controlName: "jobNameLbl" },
      { controlName: "leedLbl" },
      { controlName: "blastLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "quoteDateLbl" },
      { controlName: "expirationDateLbl" },
      { controlName: "totalBaseBidLbl" },
      { controlName: "statusLbl" },
      { controlName: "orderDateLbl" },
      { controlName: "printLbl" },
      { controlName: "exportToExcelLbl" },
      { controlName: "exportToPdfLbl" },
      { controlName: "addNewQuoteLbl" },
      { controlName: "saveLbl" },
      { controlName: "closeLbl" },
      { controlName: "updateLbl" },
      { controlName: "deleteConfirmLbl" },
      { controlName: "yesLbl" },
      { controlName: "noLbl" },

    ];
    const componentName = "kdQuote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.kdQuoteTxt = response[response.length - 1];
      console.log(response);
      this.initializeGridHeader();
    }
  }
  kdQuoteTxt: IKDQuoteLbl = {
    kdQuoteLbl: '',
    jobNumberLbl: '',
    revlbl: '',
    jobNameLbl: '',
    leedLbl: '',
    blastLbl: '',
    marketSegmentLbl: '',
    quoteDateLbl: '',
    expirationDateLbl: '',
    totalBaseBidLbl: '',
    statusLbl: '',
    actionLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    addNewQuoteLbl: '',
    saveLbl: '',
    closeLbl: '',
    updateLbl: '',
    deleteConfirmLbl: '',
    yesLbl: '',
    noLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
  }
  //#endregion
  //#region label declaration
  protected kdQuote = {
    kdQuoteLbl: 'KawneerDirect Quote',
    jobNumberLbl: 'Job Number',
    revlbl: 'Rev #',
    jobNameLbl: 'Job Name',
    totalBaseBidLbl: 'Total Base Bid',
    quoteDateLbl: 'Quote Date',
    expirationDateLbl: 'Quote Expiration Date',
    marketSegmentLbl: 'Market Segment',
    statusLbl: 'Status',
    leedLbl: 'LEED',
    print: "Print",
    actionLbl: "Actions",
    exportToExcelLbl: 'Export to Excel',
    exportToPdfLbl: 'Export to PDF',
    addNewQuoteLbl: 'Add New Quote',
    saveLbl: 'Save',
    closeLbl: 'Close',
    updateLbl: 'Update',
    deleteConfirmLbl: 'Are you sure you want to delete Quote',
    yesLbl: 'Yes',
    noLbl: 'No',
    customerNumberLbl: 'Customer Number',
    customerNameLbl: 'Customer Name',
  };
  //#endregion


  //#region Grid Events
  showQuoteDeleteConfirmBox: boolean = false;
  public removeConfirmation(dataItem): Subject<boolean> {
    this.showQuoteDeleteConfirmBox = true;
    this.gridQuoteToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }
  protected confirmQuoteRemove(shouldRemove: boolean): void {
    this.showQuoteDeleteConfirmBox = false;
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      const quoteCommonId: string = this.gridQuoteToRemove.quoteCommonId;
      this.quoteItemRemoveHandler(quoteCommonId);
    } else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridQuoteToRemove = null;
    }
  }
  quoteItemRemoveHandler(quoteCommonId: string) {
    const body: IDeleteKdQuoteBody = {
      quoteCommonId: quoteCommonId
    }
    if (quoteCommonId) {
      //this.kdQuoteLoading = true;
      this.gridQuoteToRemove.updateInProgress = true;
      this.quoteService.deleteKdQuote(body).subscribe((response) => {
        if (response) {
          this.gridQuoteToRemove.updateInProgress = false;
          this.bindKdQuotesGrid();
          this.appNotifyService.notify(NotifyType.SUCCESS, "Quote deleted succesfully");
          //this.kdQuoteLoading = false;
          this.gridQuoteToRemove = null;
        }
        else {
          this.gridQuoteToRemove.updateInProgress = false;
          this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
        }
      }, error => {
        this.gridQuoteToRemove.updateInProgress = false;
        this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
      });

    }
  }
  printMaterialProposal(quote: IQuote) {
    //call api to download material proposal
    quote.updateInProgress = true;
    const body: IPrintMaterialProposalBody = {
      quoteCommonId: quote.quoteCommonId,
      contactFullName: "",
      contactEmail: "",
      userName: this.userService.readUserObject.userName
    }
    this.quoteService.printMaterialProposal(body).subscribe((response: any) => {
      if (response) {
        if (response.urlPath === 'Error') {
          this.appNotifyService.notify(NotifyType.ERROR, "Sorry, unable to print Material Proposal.  Please correct Quote Details for missing Paint, then try again.");
        }
        else {
          const linkSource = 'data:application/pdf;base64,' + response.urlPath;
          const downloadLink = document.createElement("a");
          const fileName = body.quoteCommonId + ".pdf";
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;

      }
      quote.updateInProgress = false;
    });
  }
  //Need to test
  updateRow(quote: IQuote) {
    quote.updateInProgress = true;
    this.quoteService.updateKdQuoteStatus(quote).subscribe((response: any) => {
      if (response) {
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Status changed successfully');
        this.bindKdQuotesGrid();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
        this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
      }
      quote.updateInProgress = false;

    }, error => {
      quote.updateInProgress = false;
      this.appNotifyService.notify(NotifyType.ERROR, "An Error Occured!");
    });
  }
  //#endregion
  //#region Grid filter dropdown
  statusData = [];
  leedData = [];
  private loadKdHeaderFilterDropdown() {
    //this.statusData = [{ name: 'Active', value: 'Active' }, { name: 'Expired', value: 'Expired' }]
    //this.leedData = [{ name: 'Yes', value: true }, { name: 'No', value: false }]
    this.statusData = [{ name: 'Active', status: 'Active' }, { name: 'Expired', status: 'Expired' }]
    this.leedData = [{ name: 'Yes', leed: true }, { name: 'No', leed: false }]
  }
  gridQuoteToRemove: IQuote = null;


  //#endregion
  //#region add quote dialog 
  protected quoteDialog = {
    opened: false,
    jobNameLbl: "Job Name",
    marketSegmentLbl: "Market Segment",
    leedLbl: "LEED",
    isSubmitted: false,
    isInvalidManageSegment: false,
    isInvalidQuoteName: false,
    isInvalidLead: false,

  }
  toggleQuoteDialog() {
    this.quoteDialog.opened = !this.quoteDialog.opened;
    this.infoMessage = new Info();
    this.saveInProcess = false;
    this.addQuoteForm.reset();
    this.quoteDialog.isInvalidQuoteName = false;
    this.quoteDialog.isInvalidManageSegment = false;
    this.quoteDialog.isSubmitted = false;
  }
  protected validateAddQuoteForm(): boolean {
    let isValid = true;
    if (!this.quoteDialog) {
      return;
    }
    if (this.quoteDialog.isSubmitted) {
      if (this.f.jobName.value) {
        this.quoteDialog.isInvalidQuoteName = false;
      } else {
        this.quoteDialog.isInvalidQuoteName = true;
        isValid = false;
      }
      if (this.f.marketSegment.value) {
        this.quoteDialog.isInvalidManageSegment = false;
      } else {
        this.quoteDialog.isInvalidManageSegment = true;
        isValid = false;
      }
    }
    return isValid;
  }
  saveQuoteData() {
    this.quoteDialog.isSubmitted = true;
    if (!this.validateAddQuoteForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    console.log(this.addQuoteForm.controls)
    if (this.addQuoteForm.value.leed == null) {
      this.addQuoteForm.value.leed = false;
    }
    const controls = this.addQuoteForm.controls;
    const body = {
      jobName: controls.jobName.value,
      marketSegment: controls.marketSegment.value ? controls.marketSegment.value.name : "",
      marketSegmentId: controls.marketSegment.value ? controls.marketSegment.value.value : "",
      leed: this.addQuoteForm.value.leed as boolean
    }
    this.quoteService.addKdQuote(body as IAddQuoteBody).subscribe((response: any) => {
      console.log(response);
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;

      }
      this.bindKdQuotesGrid();
      this.addQuoteForm.reset();
    }, error => {
      this.saveInProcess = false;
      this.infoMessage.genericInProgress = "";
      this.infoMessage.genericError = this.infoMessage.errorMessage;
    })
    //call service class here
  }
  //#endregion
  //#region Grid data binding
  private bindKdQuotesGrid(): void {
    this.kdQuoteLoading = true;
    console.log(this.quoteService.kdQuote);

    this.kdQuoteGridData = process(this.quoteService.kdQuote, this.gridSettings.state);
    this.kdQuoteLoading = false;
    this.gridSettings.gridData = this.kdQuoteGridData;

  }

  //#endregion
  //#region label declaration
  protected kdQuoteGridColumnLbl = {
    jobNumber: 'Job Number',
    revision: 'Rev #',
    jobName: 'Job Name',
    totalBaseBid: 'Total Base Bid',
    quoteDate: 'Quote Date',
    expiredDate: 'Quote Expiration Date',
    marketSegment: 'Market Segment',
    customerContact: 'customerContact',
    status: 'Status',
    leed: 'LEED',
    print: "Print",
    actions: "Actions",
    invalidQuotetext: "Quote Item is not valid"
  };
  //#endregion

  //#region pagination, sorting,filtering for KD quote grid

  public kdQuoteGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'quoteNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: [{
        field: "quoteDate", operator: "gte", value: this.fromDate
      }, {
        field: "quoteDate", operator: "lte", value: this.toDate
      }]
    },
  };
  public gridSettings: GridSettings = {
    state: this.kdQuoteGridstate,
    gridData: process(this.quoteService.kdQuote, this.kdQuoteGridstate),
    columnsConfig: [{
      field: 'jobNumber',
      title: this.kdQuoteTxt.jobNumberLbl ? this.kdQuoteTxt.jobNumberLbl : this.kdQuote.jobNumberLbl,
      filterable: true
    }, {
      field: 'revision',
      title: this.kdQuoteTxt.revlbl ? this.kdQuoteTxt.revlbl : this.kdQuote.revlbl,
      filterable: true
    }, {
      field: 'jobName',
      title: this.kdQuoteTxt.jobNameLbl ? this.kdQuoteTxt.jobNameLbl : this.kdQuote.jobNameLbl,
      // filter:'date',
      // format: '{0:d}',//not able to get from and to
      filterable: true
    }, {
      field: 'leed',
      title: this.kdQuoteTxt.leedLbl ? this.kdQuoteTxt.leedLbl : this.kdQuote.leedLbl,
      _width: 100,
      filterable: true
    }, {
      field: 'marketSegment',
      title: this.kdQuoteTxt.marketSegmentLbl ? this.kdQuoteTxt.marketSegmentLbl : this.kdQuote.marketSegmentLbl,
      _width: 180,
      filterable: true
    }, {
      field: 'quoteDateForDisplay',
      title: this.kdQuoteTxt.quoteDateLbl ? this.kdQuoteTxt.quoteDateLbl : this.kdQuote.quoteDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    }, {
      field: 'expirationDateForDisplay',
      title: this.kdQuoteTxt.expirationDateLbl ? this.kdQuoteTxt.expirationDateLbl : this.kdQuote.expirationDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    }, {
      field: 'totalBaseBid',
      title: this.kdQuoteTxt.totalBaseBidLbl ? this.kdQuoteTxt.totalBaseBidLbl : this.kdQuote.totalBaseBidLbl,
      _width: 100,
      filterable: false
    }, {
      field: 'status',
      title: this.kdQuoteTxt.statusLbl ? this.kdQuoteTxt.statusLbl : this.kdQuote.statusLbl,
      _width: 100,
      filterable: true
    }
    ]
  };

  protected kdQuoteGridSortChange(sort): void {
    this.gridSettings.state.sort = sort;
    this.bindKdQuotesGrid();
  }

  protected kdQuoteGridPageChange({ skip, take }: PageChangeEvent): void {
    this.gridSettings.state.skip = skip;
    this.gridSettings.state.take;
    this.bindKdQuotesGrid();
  }

  public kdQuoteDataStateChange(state: DataStateChangeEvent): void {
    this.gridSettings.state = state;
    var newFromDate = new Date("01/01/2000");
    var newToDate = new Date("12/31/2099");
    const filters: any[] = state.filter.filters || [];
    var quoteDatefilter = filters.filter(f => f.field == "quoteDate")
    if (quoteDatefilter) {
      this.searchTextKDQuote = '';
      var tempFromFilter = quoteDatefilter.find(f => f.operator == "gte");
      if (tempFromFilter) {
        newFromDate = new Date(tempFromFilter.value);
      }
      var tempToFilter = quoteDatefilter.find(f => f.operator == "lte");
      if (tempToFilter) {
        newToDate = new Date(tempToFilter.value);
      }
      if (1==1 || (newFromDate && newFromDate < this.fromDate) || (newToDate && newToDate > this.toDate)) {
        this.fromDate = newFromDate;
        this.toDate = newToDate;
        this.loadKDQuotes();
        this.bindKdQuotesGrid();
      }
      else {
        this.bindKdQuotesGrid();
        //this.loadKDQuotes();
      }
    }
    else {
      this.bindKdQuotesGrid();
    }
  }

  //#endregion
  //storing the clicked row data in service
  goToQuoteDetail(routepath: string, item: Quote): void {
    this.quoteService.selectedQuoteHeader = item;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });
  }

  //#region Export to PDF and Excel
  async generatePDF() {
    this.loadingPDF = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.quoteService.kdQuote, {
      filter: currFilter
    });
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.kdQuoteTxt.kdQuoteLbl ? this.kdQuoteTxt.kdQuoteLbl : this.kdQuote.kdQuoteLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: this.kdQuoteTxt.customerNumberLbl ? this.kdQuoteTxt.customerNumberLbl : this.kdQuote.customerNumberLbl + ": " + this.userService.readUserObject.customerNumber,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.kdQuoteTxt.customerNameLbl ? this.kdQuoteTxt.customerNameLbl : this.kdQuote.customerNameLbl + ": " + this.userService.readUserObject.customerName,
          bold: true,
          margin: [0, 15, 0, 15]
        },
        {
          text: this.kdQuoteTxt.kdQuoteLbl ? this.kdQuoteTxt.kdQuoteLbl : this.kdQuote.kdQuoteLbl,
          style: 'sectionHeader'
        },
        {
          table: {
            headerRows: 1,
            //widths: ['*'],
            body: [
              [
                this.kdQuoteTxt.jobNumberLbl ? this.kdQuoteTxt.jobNumberLbl : this.kdQuote.jobNumberLbl,
                this.kdQuoteTxt.revlbl ? this.kdQuoteTxt.revlbl : this.kdQuote.revlbl,
                this.kdQuoteTxt.jobNameLbl ? this.kdQuoteTxt.jobNameLbl : this.kdQuote.jobNameLbl,
                this.kdQuoteTxt.leedLbl ? this.kdQuoteTxt.leedLbl : this.kdQuote.leedLbl,
                this.kdQuoteTxt.marketSegmentLbl ? this.kdQuoteTxt.marketSegmentLbl : this.kdQuote.marketSegmentLbl,
                this.kdQuoteTxt.quoteDateLbl ? this.kdQuoteTxt.quoteDateLbl : this.kdQuote.quoteDateLbl,
                this.kdQuoteTxt.expirationDateLbl ? this.kdQuoteTxt.expirationDateLbl : this.kdQuote.expirationDateLbl,
                this.kdQuoteTxt.totalBaseBidLbl ? this.kdQuoteTxt.totalBaseBidLbl : this.kdQuote.totalBaseBidLbl,
                this.kdQuoteTxt.statusLbl ? this.kdQuoteTxt.statusLbl : this.kdQuote.statusLbl
              ],
              ...filterData.data.map(p =>
                ([
                  p.jobNumber,
                  p.revision ? p.revision : '',
                  p.jobName ? p.jobName : '',
                  p.leed ? "Y" : "N",
                  p.marketSegment ? p.marketSegment : '',
                  p.quoteDate ? p.quoteDateForDisplay : '',
                  p.expirationDateForDisplay ? p.expirationDateForDisplay : '',
                  p.totalBaseBid ? p.totalBaseBid : '$0.00',
                  p.status ? p.status : '',
                ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('KawneerDirectQuote.pdf');
    this.loadingPDF = false;

  }

  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.gridSettings.state.filter;
    var filterData = process(this.quoteService.kdQuote, {
      filter: currFilter
    });

    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet(this.kdQuoteTxt.kdQuoteLbl ? this.kdQuoteTxt.kdQuoteLbl : this.kdQuote.kdQuoteLbl);
    const header = [this.kdQuoteTxt.jobNumberLbl ? this.kdQuoteTxt.jobNumberLbl : this.kdQuote.jobNumberLbl,
    this.kdQuoteTxt.revlbl ? this.kdQuoteTxt.revlbl : this.kdQuote.revlbl,
    this.kdQuoteTxt.jobNameLbl ? this.kdQuoteTxt.jobNameLbl : this.kdQuote.jobNameLbl,
    this.kdQuoteTxt.leedLbl ? this.kdQuoteTxt.leedLbl : this.kdQuote.leedLbl,
    this.kdQuoteTxt.marketSegmentLbl ? this.kdQuoteTxt.marketSegmentLbl : this.kdQuote.marketSegmentLbl,
    this.kdQuoteTxt.quoteDateLbl ? this.kdQuoteTxt.quoteDateLbl : this.kdQuote.quoteDateLbl,
    this.kdQuoteTxt.expirationDateLbl ? this.kdQuoteTxt.expirationDateLbl : this.kdQuote.expirationDateLbl,
    this.kdQuoteTxt.totalBaseBidLbl ? this.kdQuoteTxt.totalBaseBidLbl : this.kdQuote.totalBaseBidLbl,
    this.kdQuoteTxt.statusLbl ? this.kdQuoteTxt.statusLbl : this.kdQuote.statusLbl];
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let ClientIdRow = worksheet.addRow([this.kdQuoteTxt.customerNumberLbl ? this.kdQuoteTxt.customerNumberLbl : this.kdQuote.customerNumberLbl + ":" + this.userService.readUserObject.customerNumber + '']);
    ClientIdRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    let ClientNameRow = worksheet.addRow([this.kdQuoteTxt.customerNameLbl ? this.kdQuoteTxt.customerNameLbl : this.kdQuote.customerNameLbl + ":" + this.userService.readUserObject.customerName + '']);
    ClientNameRow.font = { size: 10, bold: true }
    worksheet.addRow([]);
    worksheet.addRow([]);

    let invoiceDetailsRow = worksheet.addRow([this.kdQuoteTxt.kdQuoteLbl ? this.kdQuoteTxt.kdQuoteLbl : this.kdQuote.kdQuoteLbl]);
    invoiceDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    filterData.data.map(p =>
      ([
        p.jobNumber,
        p.revision ? p.revision : '',
        p.jobName ? p.jobName : '',
        p.leed ? p.leed : '',
        p.marketSegment ? p.marketSegment : '',
        p.quoteDate ? p.quoteDate : '',
        p.expirationDateForDisplay ? p.expirationDateForDisplay : '',
        p.totalBaseBid ? p.totalBaseBid : '$0.00',
        p.status ? p.status : '',
      ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'KawneerDirectQuote.xlsx');
    })
    this.loadingExcel = false;

  }

  //#endregion
  //Add quote popup market segement dropdown change
  marketSegmentChange(event) {
    if (this.quoteDialog.isSubmitted) {
      if (event.name) {
        this.quoteDialog.isInvalidManageSegment = false;
      } else {
        this.quoteDialog.isInvalidManageSegment = true;
      }
    }
  }
  setDateFormat(date: string): Date {
    return new Date(date);
  }

  //#region grid state save
  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGrid();
  }
  public onVisibilityChange(e: any): void {
    e.columns.forEach(column => {
      this.gridSettings.columnsConfig.find(col => col.field === column.field).hidden = column.hidden;
    });

    this.saveGrid();
  }

  private saveGrid(): void {
    const gridConfig = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state
    };
    this.persistingService.set(this.userService.readUserObject.userName + 'kdQuoteGridSettings', gridConfig);
  }

  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = this.kdQuoteGridstate;// gridSettings.state;
    this.mapDateFilter(state.filter);
    state.skip = 0;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
      gridData: process(this.quoteService.kdQuote, state)
    };
  }
  private mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];

    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      }
    });
  }

  public onFilterKDQuotes(inputValue: string): void {
    var primaryFilter = this.gridSettings.state.filter;
    var primaryFilteredData = process(this.quoteService.kdQuote, {
      filter: primaryFilter
    });
    this.gridSettings.gridData = process(primaryFilteredData.data, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "jobNumber",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "jobName",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "revision",
            operator: "contains",
            value: inputValue,
          },
          //{
          //  field: "leed",
          //  operator: "contains",
          //  value: inputValue,
          //},
          {
            field: "marketSegment",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "quoteDateForDisplay",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "expirationDateForDisplay",
            operator: "contains",
            value: inputValue,
          },
          {
            field: "totalBaseBid",
            operator: "contains",
            value: inputValue,
          },

          {
            field: "status",
            operator: "contains",
            value: inputValue,
          },
        ],
      },
    });
    if (!inputValue) {
      this.gridSettings.state.skip = 0;
      this.gridSettings.state.take = 10;
      this.loadKDQuotes();
    }
    //this.dataBinding.skip = 0;
  }

  //#endregion


  initializeGridHeader() {

    this.gridSettings.columnsConfig.forEach((el) => {
      if (el.field == 'jobNumber') {
        el.title = this.kdQuoteTxt.jobNumberLbl ? this.kdQuoteTxt.jobNumberLbl : this.kdQuote.jobNumberLbl;

      }
      if (el.field == 'revision') {
        el.title = this.kdQuoteTxt.revlbl ? this.kdQuoteTxt.revlbl : this.kdQuote.revlbl;

      }
      if (el.field == 'jobName') {
        el.title = this.kdQuoteTxt.jobNameLbl ? this.kdQuoteTxt.jobNameLbl : this.kdQuote.jobNameLbl;

      }
      if (el.field == 'leed') {
        el.title = this.kdQuoteTxt.leedLbl ? this.kdQuoteTxt.leedLbl : this.kdQuote.leedLbl;
      }
      if (el.field == 'marketSegment') {
        el.title = this.kdQuoteTxt.marketSegmentLbl ? this.kdQuoteTxt.marketSegmentLbl : this.kdQuote.marketSegmentLbl;

      }
      if (el.field == 'quoteDateForDisplay') {
        el.title = this.kdQuoteTxt.quoteDateLbl ? this.kdQuoteTxt.quoteDateLbl : this.kdQuote.quoteDateLbl;
      }
      if (el.field == 'expirationDateForDisplay') {
        el.title = this.kdQuoteTxt.expirationDateLbl ? this.kdQuoteTxt.expirationDateLbl : this.kdQuote.expirationDateLbl;
      }
      if (el.field == 'totalBaseBid') {
        el.title = this.kdQuoteTxt.totalBaseBidLbl ? this.kdQuoteTxt.totalBaseBidLbl : this.kdQuote.totalBaseBidLbl;
      }
      if (el.field == 'status') {
        el.title = this.kdQuoteTxt.statusLbl ? this.kdQuoteTxt.statusLbl : this.kdQuote.statusLbl;

      }

    });
  }
}
